<template>
  <div class="container">
    <crumb prevLevel="生产企业概况" :current="levelText" />
    <div class="statistic">
      <div class="title">
        <div class="text">生产企业数量统计</div>
        <div class="sub-text">生产企业数量与批准文号数量统计</div>
      </div>
      <div class="content">
        <div class="number-container">
          <div class="number-item">
            <div class="number">{{ entNum }}</div>
            <div class="text">生产企业总数量</div>
          </div>
          <div class="number-item">
            <div class="number">{{ licenseNoZcNum }}</div>
            <div class="text">在产批准文号总数量</div>
          </div>
          <div class="number-item">
            <div class="number">{{ licenseNoTcNum }}</div>
            <div class="text">停产批准文号总数量</div>
          </div>
        </div>
        <echarts :echartsOption="echartsOption" echartsHeight="435px" />
      </div>
    </div>
    <div class="enterprise-list">
      <div class="title">
        <div class="text">生产企业列表</div>
        <div class="sub-text">{{ levelText }}</div>
      </div>
      <div class="table-list">
        <el-table :data="enterpeiseList" :cell-style="renderCell">
          <el-table-column label="统一社会信用编码" prop="org_code" />
          <el-table-column label="企业名称" prop="comp_name" />
          <el-table-column label="注册状态" prop="is_register_text" />
          <el-table-column label="所属区域" prop="org_code" />
          <el-table-column label="注册资金（人民币）" prop="reg_capital" />
          <el-table-column label="联系方式" prop="contact_tel" />
          <el-table-column label="企业邮箱" prop="email" />
          <el-table-column label="企业地址" prop="reg_address" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="font-size: 12px"
                @click="getDetail(scope.row)"
                >企业详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        @current-change="loadEnterpriseData"
        :page-size="5"
      />
    </div>
    <enterprise-detail
      :detailVisible="detailVisible"
      :closeDialog="closeDialog"
      :enterpriseId="enterpriseId"
    />
  </div>
</template>

<script>
import Crumb from 'components/crumb/crumb';
import Echarts from 'components/echarts/echarts';
import EnterpriseDetail from 'components/enterprise-detail/enterprise-detail';

const map = {
  '6': '注册资金＜1百万',
  '5': '1百万≤注册资金＜5百万',
  '4': '5百万≤注册资金＜1千万',
  '3': '1千万≤注册资金＜5千万',
  '2': '5千万≤注册资金＜1亿',
  '1': '注册资金≥1亿'
};
export default {
  data() {
    return {
      level: '',
      levelText: '',
      entNum: '',
      licenseNoZcNum: '',
      licenseNoTcNum: '',
      echartsOption: {
        grid: {
          bottom: '20%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['在产批准文号数量', '停产批准文号数量', '生产企业数量'],
          bottom: '5%'
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '批准文号数量',
            axisTick: {
              show: false
            }
          },
          {
            type: 'value',
            name: '生产企业数量',
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '在产批准文号数量',
            type: 'bar',
            barGap: '0',
            barWidth: '8px',
            itemStyle: {
              color: '#484FCF'
            },
            data: []
          },
          {
            name: '停产批准文号数量',
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: '#FFD139'
            },
            data: []
          },
          {
            name: '生产企业数量',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              color: '#2DD6AA'
            },
            data: [],
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      },
      enterpeiseList: [],
      total: 0,
      currentPage: 1,
      enterpriseId: '',
      detailVisible: false
    };
  },
  mounted() {
    this.level = this.$route.params.level;
    this.levelText = map[this.level];
    this.loadEchartsData();
    this.loadEnterpriseData(1);
  },
  methods: {
    loadEchartsData() {
      this.$request({
        url: 'rest/production/productionEntStatics',
        data: {
          json: JSON.stringify({
            params: {
              compName: '',
              isPrescribed: '',
              isRegister: '',
              isSpecial: '',
              level: this.level,
              productType: ''
            }
          })
        }
      }).then(res => {
        this.entNum = res.entNum;
        this.licenseNoZcNum = res.licenseNoZcNum;
        this.licenseNoTcNum = res.licenseNoTcNum;
        const xData = [];
        const y1Data = [];
        const y2Data = [];
        const y3Data = [];
        res.allList.forEach(item => {
          xData.push(item.short_name);
          y1Data.push(item.licenseNoZcNum);
          y2Data.push(item.licenseNoTcNum);
          y3Data.push(item.num);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = y1Data;
        this.echartsOption.series[1].data = y2Data;
        this.echartsOption.series[2].data = y3Data;
      });
    },
    loadEnterpriseData(currentPage) {
      this.currentPage = currentPage;
      this.$request({
        url: 'rest/production/productionScaleList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: 5
            },
            params: {
              compName: '',
              isPrescribed: '',
              isRegister: '',
              isSpecial: '',
              level: this.level,
              productType: ''
            }
          })
        }
      }).then(res => {
        this.total = res.total || 0;
        this.enterpeiseList = res.list.map(item => ({
          ...item,
          is_register_text: item.is_register === 0 ? '未注册' : '已注册'
        }));
      });
    },
    renderCell({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        if (row.is_register === 0) {
          return { color: '#FFB439' };
        } else {
          return { color: '#2BBF99' };
        }
      }
    },
    getDetail(row) {
      this.enterpriseId = row.id;
      this.detailVisible = true;
    },
    closeDialog() {
      this.detailVisible = false;
    }
  },
  components: {
    Crumb,
    Echarts,
    EnterpriseDetail
  }
};
</script>

<style lang="stylus" scoped>
.container
  width 1352px
  color #000
  background #fff
  border-radius 4px
  padding 0 20px
  margin-left -46px
  .title
    border-bottom 1px solid rgba(206,219,239,.5)
    padding 10px 0
    .text
      font-size 14px
      margin-bottom 5px
    .sub-text
      font-size 12px
      color #666666
  .content
    .number-container
      display flex
      justify-content center
      text-align center
      padding-top 30px
      .number-item
        margin 0 50px
        .number
          color #386CE2
          font-size 28px
          margin-bottom 5px
        .text
          font-size 12px
          color #242424
  .enterprise-list
    overflow hidden
    border-top 1px solid rgba(206,219,239,.5)
    .table-list
      margin-top 20px
    .pagination
      float right
      padding 30px 0
</style>
